/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-23 18:47:49
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import Input from 'src/types/iview/Input';
import { Toast } from 'src/util/toast';
import { modalFactory } from 'src/util/vueExtend';
import EnumOperates from 'src/enums/enumOperates';
import AuthConfigApi, {AuthConfigDOI} from './api/authConfigApi'

export namespace AuthConfigVOI {
   export interface PropsI {
       operate: string;
       id?: number;

       saveSuccess?(): void;

       cancel?(): void;
   }

   export interface FormDataI {
        mn: string;
        sim: string;
   }
}

@Component
class AuthConfigModal extends Vue.Component<AuthConfigVOI.PropsI> {
   @Prop({
       type: Function,
   })
   cancel!: () => void;

   @Prop({
       type: Number,
   })
   id!: number;

   @Prop({
       type: String,
   })
   operate!: string;

   @Prop({
       type: Function,
   })
   saveSuccess!: () => void;

   visible: boolean = false;

   loading: boolean = false;

   formData: AuthConfigVOI.FormDataI = {
       mn: '',
       sim: '',
   };
   rules: any = {};

   close() {
       this.cancel && this.cancel();
       this.closeModal();
   }

   closeModal() {
       this.visible = false;
       this.$emit('close', false);
   }

   async save() {
       if (!(await this.$validate('formValidate'))) {
           return;
       }
       let res;
       this.loading = true;
       let params: AuthConfigDOI.FormDataI = {
           ...this.formData,
       };
       res = await AuthConfigApi.add(params);
       this.loading = false;
       let { code } = res;
       if (code === 0) {
           Toast.success('成功');
           this.saveSuccess();
           this.closeModal();
       }
   }

   
   render(h) {
       return (
           <Modal title={this.operate+"序列号"} width="800" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
               <i-form ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                   <form-item required  label="序列号" prop="mn" style="display: inline-block;width:45%">
                       <Input  placeholder="请输入" v-model={this.formData.mn} />
                   </form-item>
                   <form-item required  label="SIMID" prop="sim" style="display: inline-block;width:45%">
                       <Input  placeholder="请输入" v-model={this.formData.sim} />
                   </form-item>
               </i-form>
               <div slot="footer">
                   <Button type="primary" ghost on-click={this.close}>
                       取消
                   </Button>
                   <Button type="primary" on-click={this.save} loading={this.loading}>
                       保存
                   </Button>
               </div>
           </Modal>
       );
   }
}

export default function alertAuthConfigModal(operate: string, id?: number): Promise<boolean> {
   return new Promise((resolve, reject) => {
       modalFactory<AuthConfigVOI.PropsI>(AuthConfigModal)({
           id,
           operate,
           saveSuccess() {
               resolve(true);
           },
           cancel() {
               resolve(false);
           },
       });
   });
}